import React, { useEffect, useState } from "react";
import "./FinancialPerformance.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  submitCorporateAndOrgStructureFailure,
  submitCorporateAndOrgStructureRequest,
} from "../../../../store/features/actions/corporateAndOrgStructureActions";
import {
  getAllPageInsights,
  getAllSubdimensionMatches,
} from "../../../../services/commonService";
import HeadlineFinancialMetrics from "./HeadlineFinancialMetrics";
import PricingAndCostStrucures from "./PricingAndCostStructures";
import InvestorGuidanceAndBoardCommentary from "./InvestorGuidanceAndBoardCommentary";
import RevenueBreakdown from "./RevenueBreakdown";
import TopRightActionLinks from "../TopRightActionLinks";
import InsightBlock from "../InsightBlock";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../Chat/AiChat";
import GenericTableSkeleton from "../../skeletons/tableSkeleton/genericTableSkeleton";

function FinancialPerformance() {
  const { clientName, competitorName } = useParams();
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const [headlineFinancialMetrics, setHeadlineFinancialMetrics] = useState([]);
  const [pricingAndCostStructures, setPricingAndCostStructures] = useState([]);
  const [
    investorGuidanceAndBoardCommentary,
    setInvestorGuidanceAndBoardCommentary,
  ] = useState([]);
  const [revenueBreakdown, setRevenueBreakdown] = useState([]);
  const dispatch = useDispatch();

  const { loading, data, error } = useSelector(
    (state) => state.corporateAndOrgStructureReducer
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    dispatch(
      submitCorporateAndOrgStructureRequest("Financial Performance & Strategy", clientName)
    );
  }, []);

  useEffect(() => {
    const tempHeadlineFinMetrics = getAllSubdimensionMatches(
      data,
      "Headline Financial Metrics"
    );
    setHeadlineFinancialMetrics(tempHeadlineFinMetrics);

    const tempPricingAndCostStructures = getAllSubdimensionMatches(
      data,
      "Pricing & Cost Structures"
    );
    setPricingAndCostStructures(tempPricingAndCostStructures);

    const tempInvestorGuidanceAndBoardCommentary = getAllSubdimensionMatches(
      data,
      "Investor Guidance & Board Commentary"
    );
    setInvestorGuidanceAndBoardCommentary(
      tempInvestorGuidanceAndBoardCommentary
    );

    const tempRevenueBreakdown = getAllSubdimensionMatches(
      data,
      "Revenue Breakdown"
    );
    setRevenueBreakdown(tempRevenueBreakdown);

    const { positive, negative, sowhat } = getAllPageInsights(data);
    setPagePositives(positive || []);
    setPageNegatives(negative || []);
    setPageSoWhat(sowhat || []);
  }, [data]);

  const handleAiConversation = () => console.log("AI conversation clicked");
  const handleDownload = () => console.log("Download clicked");

  const actions = [
    {
      type: "conversation",
      title: "Conversation",
      onClick: () => {
        setShowConversationModal((prev) => !prev);
      },
    },
    { type: "download", title: "Download", onClick: handleDownload },
  ];

  return (
    <div className="financial_wrapper">
      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        <InsightBlock
          title={"Financial Performance"}
          overview={`Benchmarking ${
            clientName ?? "HB Fuller"
          }’s revenue performance, cost levers, investor confidence, and financial strategy against public peers like Henkel and Bostik.`}
          actions={actions}
          pagePositives={pagePositives}
          pageNegatives={pageNegatives}
          pageSoWhat={pageSoWhat}
        />
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        <HeadlineFinancialMetrics
          headlineFinancialMetrics={headlineFinancialMetrics}
        />
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        <PricingAndCostStrucures
          pricingAndCostStructures={pricingAndCostStructures}
        />
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        <InvestorGuidanceAndBoardCommentary
          investorGuidanceAndBoardCommentary={
            investorGuidanceAndBoardCommentary
          }
        />
      )}

      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        <RevenueBreakdown revenueBreakdown={revenueBreakdown} />
      )}

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This:{" "}
                    {competitorName ?? "Tailored Chemical Products"} - Market
                    Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={""} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default FinancialPerformance;
